import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface RetargetingState {
  /** Read back by TableFilters so a reopened drawer shows the live selection. */
  selectedCampaignFilters: Record<string, any>;
}

const initialState: RetargetingState = { selectedCampaignFilters: {} };

const retargetingSlice = createSlice({
  name: 'retargeting',
  initialState,
  reducers: {
    setSelectedCampaignFilters: (
      state,
      action: PayloadAction<Record<string, any>>
    ) => {
      state.selectedCampaignFilters = action.payload;
    },
  },
});

export const { setSelectedCampaignFilters } = retargetingSlice.actions;
export default retargetingSlice.reducer;
